const addonCheckbox = document.querySelector('.addon-checkbox');
const hiddenInputs = document.querySelectorAll('.addon-hidden-input');
const hiddenIdInputs = document.querySelectorAll('.addon-hidden-id');

addonCheckbox.addEventListener('change', function() {
    for (const hiddenInput of hiddenInputs) {
        hiddenInput.disabled = !hiddenInput.disabled
    }
    const randomId = generateString(16);
    for (const hiddenIdInput of hiddenIdInputs) {
        hiddenIdInput.value = randomId;
    }
});

if (document.querySelector('.quantity__input')) {
    document.querySelector('.quantity__input').addEventListener('change', function() {
        document.getElementById('addonQty').value = this.value;
    });
}
